import OrderableModel from '@/models/OrderableModel';
import store from '@/store';

export default class TicketStatus extends OrderableModel {

    static TYPE_OPEN = 1;
    static TYPE_CLOSED = 2;
    static TYPE_ARCHIVED = 3;
    static TYPE_WAITING_FOR_REPLY = 4;
    static TYPE_GOT_REPLY = 5;
    static TYPE_SCHEDULED = 6;

    get route () {
        return 'ticket-statuses';
    }

    static get className () {
        return 'TicketStatus';
    }

    static get isInStore () {
        return true;
    }

    static getIdByType (type) {
        const types = {
            open: this.TYPE_OPEN,
            closed: this.TYPE_CLOSED,
            archived: this.TYPE_ARCHIVED,
            waiting_for_reply: this.TYPE_WAITING_FOR_REPLY,
            got_reply: this.TYPE_GOT_REPLY,
            scheduled: this.TYPE_SCHEDULED
        };

        const status = store.getters.getFilteredValue('ticketStatuses', (status) => {
            return status.internal_type === types[type];
        });

        return status ? status.id : null;
    }
}
